import * as React from "react";
import { SVGProps } from "react";
const SvgQuote = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M25 4c2.2 0 4 1.8 4 4v11c0 2.2-1.8 4-4 4h-3v5a1 1 0 0 1-1.602.799L12.7 23H7c-2.2 0-4-1.8-4-4V8c0-2.2 1.8-4 4-4h18Zm0 2H7c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h6c.2 0 .4.1.6.2L20 26v-4a1 1 0 0 1 1-1h4c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2Zm-3.5 3a.5.5 0 0 1 .5.5l-.001 4.333a.5.5 0 0 1-.1.3L19.15 17.8a.5.5 0 0 1-.4.2h-1.345a.25.25 0 0 1-.224-.362L18.999 14H17.5a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h4Zm-7 0a.5.5 0 0 1 .5.5l-.001 4.333a.5.5 0 0 1-.1.3L12.15 17.8a.5.5 0 0 1-.4.2h-1.345a.25.25 0 0 1-.224-.362L11.999 14H10.5a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h4Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgQuote;
